import { z } from 'zod/v4';

export const AdminDocumentTypeSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  documentClass: z.enum(['TRANSACTIONAL', 'COMPANY']),
  hierarchyId: z.string().nullable(),
  impactAreaId: z.string().nullable(),
  impactAreaDescription: z.string().nullable(),
  isDeprecated: z.boolean(),
  documentCount: z.number(),
  createdAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  updatedAt: z.coerce.date().nullable(),
  updatedByUserId: z.string().nullable(),
});

export type AdminDocumentTypeType = z.infer<typeof AdminDocumentTypeSchema>;
